import React, { RefObject }  from "react";
import { ErrorWindow } from "../Components/ErrorWindow";
import {
    ScatterChart,
    Scatter,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ErrorBar,
    Legend
} from "recharts";
import { DataHelper } from "../Helpers/DataHelper";
import { ChartDataModel } from "../Models/ChartDataModel";
import { LoadingWidget } from "../Components/LoadingWidget";
import { StudyModel } from "../Models/StudyModel";
import { InputItem } from "../Components/InputItem";

export class FlowValues extends React.Component<
{
    dataClient: DataHelper,
    studyId: string,
    studySelected: StudyModel, 
    otherFilters: any,
    fieldsAvailable: any
},
{
    flowData: ChartDataModel[],
    isBusy: boolean,
    labelType: string,
    additionalFilter:string,
    fieldName:string
}
> {

    //Data structure: 
    // data = [ 
    //     {
    //         "x": category,
    //         "y": number,
    //         "errorY": [minNumber, maxNumber]
    //     }];
    errorWindow:  RefObject<ErrorWindow>;
    constructor(props: any) {
        super(props);
        this.errorWindow = React.createRef();
        if (props.studySelected.labelTypes?.at(0)){
        this.state = {
            flowData: [],
            isBusy: false,
            labelType: props.studySelected.labelTypes?.at(0) as string,
            additionalFilter: "All",
            fieldName: "Mean Flow"
        }}
        else{
            this.state = {
                flowData: [],
                isBusy: false,
                labelType: "",
                additionalFilter: "All",
                 fieldName: "Mean Flow"
            }
        }
    }
    
    static defaultProps = {
        //Set any properties that are optional when creating the component.
        otherFilters: {
            "Probe Size": "measurementfield:probeSize"
        },
        fieldsAvailable: {
            "Mean Flow": "mean",
            "Pulsatility Index": "pI",
            "ACI": "aCIMean"
        }
      }


    getData = (studyId: string, labelType?: string, additionalFilter?: string, fieldName?: string): void => {
        this.setState({ isBusy: true });
        let labelToUse = labelType ? labelType : (this.state.labelType ? this.state.labelType : "");
        let fieldNameToUse = fieldName ? fieldName : (this.state.fieldName ? this.state.fieldName : "");
        if (Object.keys(this.props.fieldsAvailable).indexOf(fieldNameToUse) !== -1)
        {
            fieldNameToUse = this.props.fieldsAvailable[fieldNameToUse];
        }

        if (Object.keys(this.props.otherFilters).indexOf(labelToUse) !== -1)
        {
            labelToUse = this.props.otherFilters[labelToUse];
        }
        this.props.dataClient.CallDashboardService("GetFlowValues", {}, {studyId: studyId, labelType: labelToUse, fieldName: fieldNameToUse, additionalFilter: additionalFilter ? additionalFilter : this.state.additionalFilter}, (result: string) => {
            let flowValues = JSON.parse(result);
            // if (callback)
            //     callback(flowValues);

            this.setState({ labelType: labelType ? labelType : this.state.labelType, fieldName: fieldName ? fieldName : this.state.fieldName, flowData: flowValues, isBusy: false })
        }, (stautus:number, errorMessage:string)=>{
            // if (callback)
            // callback([1,2,3]);
            (this.errorWindow.current as ErrorWindow).show(stautus, errorMessage)}, "GET", false);

    }

    
    componentDidMount(): void {}

    onDropdownChange = (name:string, value: string): void => {
        if (name === "labelType")
        {
            this.getData(this.props.studySelected.id as string, value as string)
        }else
        if (name === "additionalFilter")
        {
            this.getData(this.props.studySelected.id as string, "",  value as string)
        }else
        if (name === "fieldName")
        {
            this.getData(this.props.studySelected.id as string, "",  "", value as string)
        }

    }

    render() {

        let options = [...this.props.studySelected.labelTypes as string[]];
        options.push(...Object.keys(this.props.otherFilters));

        let fieldNames = Object.keys(this.props.fieldsAvailable);
        let avgMeanTestDiv = <></>;
        if (this.state.flowData && this.state.flowData.length > 0 && this.state.flowData[this.state.flowData.length-1])
        {
            avgMeanTestDiv  = <div id="averagemeanflowhiddenttestdiv" style={{display: "none"}}>{this.state.flowData[this.state.flowData.length-1].value1}</div>
        }

        return (
            <>
            <ErrorWindow ref={this.errorWindow}/>
            <h3>Average {this.state.fieldName}</h3>
            {avgMeanTestDiv}
                <div className="chartDropdown">
                    <InputItem title={"Select label type"} type={"dropdown"} name={"labelType"} onChange={this.onDropdownChange} value={this.state.labelType?this.state.labelType:options[0]} options={options}></InputItem>
                    <InputItem title={"Filter"} type={"dropdown"} name={"additionalFilter"} onChange={this.onDropdownChange} value={this.state.additionalFilter} options={["All", "Qualified"]}></InputItem>
                    <InputItem title={"Field to show"} type={"dropdown"} name={"fieldName"} onChange={this.onDropdownChange} value={this.state.fieldName?this.state.fieldName:fieldNames[0]} options={fieldNames}></InputItem>
                </div>
                <div className="chartHolder">
                    <ScatterChart
                        width={680}
                        height={300}
                        margin={{ top: 20, right: 20, bottom: 0, left: 20 }}
                    >
                        <CartesianGrid />
                        <XAxis dataKey="name" type="category" name="labels" />
                        <YAxis dataKey="value1" type="number" name="avgmeanflow" unit={this.state.fieldName === "Mean Flow" ? " mL/min" : ""}/>
                        <Tooltip />
                        <Scatter name={"Average " + this.state.fieldName} dataKey={"value1"} data={this.state.flowData} fill="#F5812E">
                            <ErrorBar dataKey="errorY" width={4} strokeWidth={2} stroke="#9FB6E8" direction="y" />
                        </Scatter>
                        <Legend />
                    </ScatterChart>
                    <LoadingWidget visible={this.state.isBusy} zIndexLayer={0}></LoadingWidget>
                </div>
            </>
        );
    }
}
